export default __webpack_public_path__ + "img/99d8999fcd1ea0b2739e21da65709d77.png";